import styled, {css, keyframes} from "styled-components";
import {Title1} from "../../../../styles/business-components";

export const Container = styled.div`
  padding: 50px 200px 100px 200px;
`

export const Title = styled(Title1)`
  text-align: center;
`

export const TabsBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 100px;
  margin-top: 100px;
`

export const TabsMenu = styled.div`
  display: flex;
  flex-basis: 30%;
  flex-direction: column;
  gap: 20px;
`

export const TabsMenuItem = styled.div<{active?: boolean}>`
  padding: 10px 0;
  border-radius: 40px;
  border: 1px solid;
  font-size: 20px;
  font-weight: 600;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  ${({active, theme}) => active
    ? css`
        border: 1px solid ${theme.business.colors.functionalTabItemActiveColor};
        color: ${theme.business.colors.functionalTabItemActiveColor};
        background: ${theme.business.colors.functionalTabItemActiveBackground};
      `
    : css`
        border: 0;
        color: ${theme.business.colors.functionalTabItemColor};
        background: ${theme.business.colors.functionalTabItemBackground};
      `
  }
`

export const Content = styled.div`
  flex-basis: 70%;
`

export const Item = styled.div<{active?: boolean}>`
  display: ${({active}) => active ? 'grid' : 'none'};
  grid-template-columns: 1fr 400px;
  gap: 100px;
`

export const ItemTextBlock = styled.div``

export const ItemTitle = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 60px;
  margin-bottom: 50px;
  text-transform: uppercase;
  white-space: pre-line;
`

export const ItemText = styled.p`
  font-size: 24px;
  font-weight: 400;
  line-height: 60px;
`

export const ItemImageBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: 80%;
`

const animation1 = keyframes`
    from {
      opacity: 0;
      scale: 0.8;
    } 
    to {
      opacity: 1;
      scale: 1;
    }
`

export const ItemImage = styled.img`
  border-radius: 30px;
  animation: ${animation1} 400ms ease-out;
`
